import { IAccount } from '@models/Account';
import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import AuthServiceApi from 'apis/api/Auth';
import DataManagementApi from 'apis/api/DataManagement';
import { IBranch } from 'models/Branch';
import { ICustomer } from 'models/Customer';
import { IOptionData } from 'models/OptionData';
import { IStaff } from 'models/Staff';
import { IStock } from 'models/Stock';
import { IProductCategory } from 'models/StockManage/CateProductManage';
import { ITechnicianZone } from 'models/TechnicianZone';
import { ITimeSelect } from 'models/TimeSelect';
import { IOrderSelect } from 'models/OrderSelect';
import moment from 'moment';
import { dark, light } from 'styles/Theme.styled';
import { getAllTypeOrders } from './createOrder.slice';

export const getAllBranch = createAsyncThunk('select/getAllBranch', async () => {
  const response = await DataManagementApi.GetAllBranch();
  return response.data;
});

export const getAllTechnicianZone = createAsyncThunk('select/getAllTechnicianZone', async () => {
  const response = await DataManagementApi.GetAllTechnicianZone();
  return response.data;
});

export const searchCustomersByPhone = createAsyncThunk('select/searchCustomersByPhone', async (textSearch: any) => {
  const response = await DataManagementApi.SearchCustomerByPhone(textSearch);
  return response.data;
});

export const searchCustomersByText = createAsyncThunk('select/searchCustomersByText', async (textSearch: any) => {
  const response = await DataManagementApi.SearchCustomer(textSearch);
  return response.data;
});

export const getUsersAccountant = createAsyncThunk('select/getUsersAccountant', async () => {
  const response = await AuthServiceApi.GetUsersByRoleV2('Accountant');
  return response.data;
});

export const getUsersSale = createAsyncThunk('select/getUsersSale', async () => {
  const response = await AuthServiceApi.GetUsersByRoleV2('Sale');
  return response.data;
});
export const getUsersWareHouse = createAsyncThunk('select/getUserWareHouse', async () => {
  const response = await AuthServiceApi.GetUsersByRoleV2('WareHouse');
  return response.data;
});

export const getUsersTechnician = createAsyncThunk('select/getUsersTechnician', async () => {
  const response = await AuthServiceApi.GetUsersByRoleV2('Technician');
  return response.data;
});

export const getAllUserSales = createAsyncThunk('adminConfig/getAllUserSales', async () => {
  const response = await AuthServiceApi.GetAllUserSales();
  return response.data;
});

interface ISelectLoadedData {
  orderLoaded?: boolean | null;
  branchLoaded?: boolean | null;
  technicianZoneLoaded?: boolean | null;
  techStaffLoaded?: boolean | null;
  salesListLoaded?: boolean | null;
  saleStaffLoaded?: boolean | null;
  // deviceGroupLoadCompanyId: { companyId: number; groupId: number } | null;
  // pointSelectLoadCompanyId: number | null;
}

type initialStateType = {
  loadedData: ISelectLoadedData;
  customerSelectData: Array<ICustomer>; // danh sách khách hàng từ ô tìm kiếm nhanh KH của đơn hàng
  orderSelectData: Array<IOrderSelect>;
  techSelectData: Array<IStaff>;
  staffSelectData: Array<IStaff>;
  stockSelectData: Array<IStock>;
  branchSelectData: Array<IBranch>;
  technicianZoneSelectData: Array<ITechnicianZone>;

  // danh sách các tk user
  usersAccountant: Array<IAccount>;
  usersSale: Array<IAccount>;
  usersWareHouse: Array<IAccount>;
  usersTechnician: Array<IAccount>;
  salesListData: Array<any>;
  typeCoopData: Array<IOptionData>;
  vatData: Array<IOptionData>;

  selectedTime?: ITimeSelect;
  resetTime?: boolean;
  preSelectDate7?: ITimeSelect;

  selectedOrder?: IOrderSelect | undefined;
  selectedArrayOrder?: any;
  selectedArrayListSalesV2?: any;

  selectedBranch?: IBranch | undefined;
  listTechBranch?: any;
  listAccountantBranch?: any;
  listOperatingBranch?: any;

  selectedStatus?: string | undefined;
  orderCompanyName?: string | undefined;
  orderTypeCompany?: string | undefined;
  orderOperateCollected?: any | undefined;
  orderAccountCollected?: any | undefined;
  orderCoopType?: any | undefined;
  orderCoopTypeV2?: any | undefined;
  orderTime?: any | undefined;
  listOperatings?: any | undefined;
  listAccountants?: any | undefined;
  listSales?: any | undefined;
  listSalesV2?: any | undefined;
  isBlock?: any | undefined;
  paymentMethod?: any | undefined;
  typeBranch?: any | undefined;
  selectedStock?: IStock;
  selectedStaff?: IStaff;
  selectedStaffTech?: any | undefined;
  categorySelect?: IProductCategory;
  selectedCustomer?: ICustomer;
  selectedMultipleStock?: Array<IOptionData>;
  selectedMultipleStaff?: Array<IOptionData>;
  selectedMultipleCustomer?: Array<IOptionData>;
  selectedMultipleCategory?: Array<IOptionData>;
  selectedMultipleOrder?: Array<IOptionData>;
  // lưu trữ theme trình duyệt
  themeSelected?: any;
  // thu gọn navbar menu
  isCollapsedNav?: any;
  // lưu trữ link menu đang chọn
  activeMenuHeader?: any;
  // btn trên menu header
  activeButtonHeader: string | undefined;
  // loading api
  isLoadingApi?: boolean;
  // hiện thông báo xác nhận chung...
  openConfirmModal?: boolean;
  // cấu hình json từ server
  configStart?: any;
};

const initialState: initialStateType = {
  customerSelectData: [],

  listTechBranch: [],
  listAccountantBranch: [],
  listOperatingBranch: [],
  techSelectData: [],
  staffSelectData: [],
  stockSelectData: [],
  orderSelectData: [],
  branchSelectData: [],
  salesListData: [],
  technicianZoneSelectData: [],
  usersAccountant: [],
  usersSale: [],
  usersWareHouse: [],
  usersTechnician: [],
  typeCoopData: [
    { value: 1, label: ' Khách lẻ' },
    { value: 2, label: 'Công ty' },
    { value: 3, label: 'Đại lý' },
    { value: 4, label: 'HTX' },
    { value: 5, label: 'Showroom' },
    { value: 6, label: 'Cộng tác viên' }
  ],
  vatData: [
    {
      value: '0',
      label: 'Không rõ'
    },
    {
      value: '7',
      label: '7%'
    },
    {
      value: '10',
      label: '10%'
    }
  ],
  selectedTime: {
    beginTime: moment().startOf('day').toISOString(true),
    endTime: moment().endOf('day').toISOString(true)
  },
  resetTime: false,
  selectedMultipleStock: [],
  selectedMultipleStaff: [],
  selectedMultipleCustomer: [],
  selectedMultipleCategory: [],
  selectedMultipleOrder: [],
  themeSelected: dark,
  isCollapsedNav: false,
  activeButtonHeader: undefined,
  isLoadingApi: false,
  openConfirmModal: false,
  loadedData: {
    orderLoaded: null,
    branchLoaded: null,
    technicianZoneLoaded: null,
    techStaffLoaded: null,
    salesListLoaded: null
  },
  configStart: null,
  preSelectDate7: {
    beginTime: moment().add(-6, 'days').startOf('day').toISOString(true),
    endTime: moment().endOf('day').toISOString(true)
  }
};

const selectSlide = createSlice({
  name: 'select',
  initialState: initialState,
  reducers: {
    resetState: state => {
      state.customerSelectData = [];
    },
    updatePageLoadingApi: (state, action: PayloadAction<boolean>) => {
      state.isLoadingApi = action.payload;
    },
    updateOpenConfirmModal: (state, action: PayloadAction<boolean>) => {
      state.openConfirmModal = action.payload;
    },
    updateSelectDateTime: (state, action: PayloadAction<ITimeSelect>) => {
      state.selectedTime = action.payload;
    },
    // ĐÁNH DẤU ĐỂ RESET DATETIME LỊCH
    updateResetDateTime: (state, action: PayloadAction<boolean>) => {
      state.resetTime = action.payload;
    },
    updateSelectDateTime7: (state, action: PayloadAction<ITimeSelect>) => {
      state.preSelectDate7 = action.payload;
    },
    updateSelectCustomer: (state, action: PayloadAction<string>) => {
      const result = state.customerSelectData.find(item => item.name === action.payload);
      state.selectedCustomer = result;
    },
    updateSelectStaff: (state, action: PayloadAction<string>) => {
      const result = state.techSelectData.find(item => item.username === action.payload);
      state.selectedStaff = result;
      state.selectedStaffTech = action.payload === '-1' ? undefined : action.payload;
    },
    // updateSelectCategory: (state, action: PayloadAction<string>) => {
    //   const result = state.categorySelectData.find(item => item.Name === action.payload);
    //   state.selectedCategory = result;
    // },
    updateSelectOrder: (state, action: PayloadAction<any>) => {
      if (action.payload?.type === 'mutiple') {
        state.selectedArrayOrder = action.payload;
      } else {
        const result = state.orderSelectData.find(item => item.id === action.payload);
        state.selectedOrder = result;
      }
    },

    updateSelectListSalesV2: (state, action: PayloadAction<any>) => {
      if (action.payload?.type === 'mutiple') {
        state.selectedArrayListSalesV2 = action.payload;
      }
      // else {
      //   const result = state.orderSelectData.find(item => item.id === action.payload);
      //   state.selectedOrder = result;
      // }
    },
    updateSelectStatus: (state, action: PayloadAction<string>) => {
      state.selectedStatus = action.payload === '-1' ? undefined : action.payload;
    },
    updateCompanyName: (state, action: PayloadAction<string>) => {
      state.orderCompanyName = action.payload === '-1' ? undefined : action.payload;
    },
    updateTypeCompany: (state, action: PayloadAction<string>) => {
      state.orderTypeCompany = action.payload === '-1' ? undefined : action.payload;
    },
    updateOperateCollected: (state, action: PayloadAction<string>) => {
      state.orderOperateCollected = action.payload === '-1' ? undefined : action.payload;
    },
    updateAccountCollected: (state, action: PayloadAction<string>) => {
      state.orderAccountCollected = action.payload === '-1' ? undefined : action.payload;
    },
    updateCoopType: (state, action: PayloadAction<string>) => {
      state.orderCoopType = action.payload === '-1' ? undefined : action.payload;
    },
    updateCoopTypeV2: (state, action: PayloadAction<any>) => {
      state.orderCoopTypeV2 = action.payload === '-1' ? undefined : action.payload;
    },
    updateTime: (state, action: PayloadAction<string>) => {
      state.orderTime = action.payload === 'TG Hoàn tất' ? undefined : action.payload;
    },
    updateListSales: (state, action: PayloadAction<string>) => {
      state.listSales = action.payload === '-1' ? undefined : action.payload;
    },
    updateListOperating: (state, action: PayloadAction<string>) => {
      state.listOperatings = action.payload === '-1' ? undefined : action.payload;
    },
    updateListAccountant: (state, action: PayloadAction<string>) => {
      state.listAccountants = action.payload === '-1' ? undefined : action.payload;
    },
    updateListSalesV2: (state, action: PayloadAction<any>) => {
      state.listSalesV2 = action.payload === '-1' ? undefined : action.payload;
    },
    updateIsBlock: (state, action: PayloadAction<any>) => {
      state.isBlock = action.payload === '-1' ? undefined : action.payload;
    },
    updateLPaymentMethod: (state, action: PayloadAction<string>) => {
      state.paymentMethod = action.payload === '-1' ? undefined : action.payload;
    },
    updateTypeBranch: (state, action: PayloadAction<string>) => {
      state.typeBranch = action.payload === 'CN thực hiện' ? undefined : action.payload;
    },
    updateSelectBranch: (state, action: PayloadAction<any>) => {
      const result = state.branchSelectData.find(item => item.id === action.payload);
      state.selectedBranch = result;
    },
    updateListTechBranch: (state, action: PayloadAction<any>) => {
      state.listTechBranch = action.payload || [];
    },
    updateListAccountantBranch: (state, action: PayloadAction<any>) => {
      state.listAccountantBranch = action.payload || [];
    },
    updateListOperatingBranch: (state, action: PayloadAction<any>) => {
      state.listOperatingBranch = action.payload || [];
    },
    updateSelectStock: (state, action: PayloadAction<string>) => {
      const result = state.stockSelectData.find(item => item.Name === action.payload);
      state.selectedStock = result;
    },
    updateSelectMultipleStock: (state, action: PayloadAction<IOptionData[]>) => {
      state.selectedMultipleStock = action.payload;
    },

    updateSelectMultipleStaff: (state, action: PayloadAction<IOptionData[]>) => {
      state.selectedMultipleStaff = action.payload;
    },

    updateSelectMultipleCustomer: (state, action: PayloadAction<IOptionData[]>) => {
      state.selectedMultipleCustomer = action.payload;
    },
    updateSelectMultipleCategory: (state, action: PayloadAction<IOptionData[]>) => {
      state.selectedMultipleCategory = action.payload;
    },
    updateSelectMultipleOrder: (state, action: PayloadAction<IOptionData[]>) => {
      state.selectedMultipleOrder = action.payload;
    },
    updateThemeSelected: (state, action: PayloadAction<any | undefined>) => {
      state.themeSelected = action.payload;
    },
    updateIsCollapseNav: (state, action: PayloadAction<boolean>) => {
      state.isCollapsedNav = action.payload;
    },
    // DÙNG ĐỂ TÔ MÀU MENU
    updateActiveMenuHeader: (state, action: PayloadAction<any | undefined>) => {
      state.activeMenuHeader = action.payload;
    },
    updateActiveButtonHeader: (state, action: PayloadAction<string | undefined>) => {
      state.activeButtonHeader = action.payload;
    },
    updateConfigStart: (state, action: PayloadAction<any | undefined>) => {
      state.configStart = action.payload;
    }
  },
  extraReducers: builder => {
    builder.addCase(getAllTypeOrders.fulfilled, (state, action) => {
      console.log('addCase getAllTypeOrders', action.payload?.data);
      state.orderSelectData = action.payload?.data || [];
      state.loadedData.orderLoaded = true;
    });
    builder.addCase(getAllBranch.fulfilled, (state, action) => {
      console.log('addCase getAllBranch', action.payload?.data);
      state.branchSelectData = action.payload?.data;
      state.loadedData.branchLoaded = true; // đã load chi nhánh đầu
    });
    builder.addCase(getAllTechnicianZone.fulfilled, (state, action) => {
      console.log('addCase getAllTechnicianZone');
      state.technicianZoneSelectData = action.payload?.data || [];
      state.loadedData.technicianZoneLoaded = true; // đã load chi nhánh đầu
    });
    builder.addCase(searchCustomersByPhone.fulfilled, (state, action) => {
      console.log('addCase searchCustomersByPhone');
      state.customerSelectData = (action.payload?.data && [action.payload?.data]) || [];
    });
    builder.addCase(searchCustomersByText.fulfilled, (state, action) => {
      console.log('addCase searchCustomersByText');
      state.customerSelectData = (action.payload?.data && action.payload?.data) || [];
    });
    builder.addCase(getUsersAccountant.fulfilled, (state, action) => {
      console.log('addCase getUsersAccountant');
      state.usersAccountant = action.payload?.data || [];
    });
    builder.addCase(getUsersSale.fulfilled, (state, action) => {
      console.log('addCase getUsersSale');
      state.usersSale = action.payload?.data || [];
      state.loadedData.saleStaffLoaded = true;
    });
    builder.addCase(getUsersWareHouse.fulfilled, (state, action) => {
      console.log('addCase getUserWareHouse');
      state.usersWareHouse = action.payload?.data || [];
    });
    builder.addCase(getUsersTechnician.fulfilled, (state, action) => {
      console.log('addCase getUsersTechnician');
      state.usersTechnician = action.payload?.data || [];
      state.techSelectData = action.payload?.data || [];
      state.loadedData.techStaffLoaded = true;
    });
    builder.addCase(getAllUserSales.fulfilled, (state, action) => {
      console.log('addCase getAllUserSales');
      // state.usersTechnician = action.payload?.data || [];
      state.salesListData = action.payload?.data || [];
      state.loadedData.salesListLoaded = true;
    });
  }
});

export const {
  resetState,
  updateOpenConfirmModal,
  updatePageLoadingApi,
  updateSelectDateTime,
  // RESET LỊCH
  updateResetDateTime,
  updateSelectCustomer,
  updateSelectStaff,
  updateSelectStock,
  updateSelectOrder,
  updateSelectListSalesV2,
  updateSelectBranch,
  updateListTechBranch,
  updateListAccountantBranch,
  updateListOperatingBranch,
  updateSelectStatus,
  // updateSelectCategory,
  updateSelectMultipleStock,
  updateSelectMultipleStaff,
  updateSelectMultipleCustomer,
  updateSelectMultipleCategory,
  updateSelectMultipleOrder,
  updateThemeSelected,
  updateIsCollapseNav,
  updateActiveMenuHeader,
  updateActiveButtonHeader,
  updateConfigStart,
  updateCompanyName,
  updateTypeCompany,
  updateOperateCollected,
  updateAccountCollected,
  updateCoopType,
  updateCoopTypeV2,
  updateTime,
  updateListSales,
  updateListOperating,
  updateListAccountant,
  updateListSalesV2,
  updateIsBlock,
  updateLPaymentMethod,
  updateTypeBranch,
  updateSelectDateTime7
} = selectSlide.actions;

export default selectSlide.reducer;
